import styles from './Footer.module.css'
import { BUILD, buildLabel, builtAtShort, buildDetail } from '../lib/buildInfo.js'

// Version + commit + the bundle this page is actually running. See
// lib/buildInfo.js for why the version alone could not answer "did it deploy".

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        {/* Canonical SR mark — owned asset served from this repo (public/brand). */}
        <img
          className={styles.mark}
          src="/brand/sr-monogram.png"
          alt="Southern Recognition"
          width="18"
          height="18"
        />
        <span>
          © {year} Southern Recognition Inc. — Unified Platform
        </span>
      </div>
      <div className={styles.spacer} />
      <nav className={styles.links} aria-label="Footer">
        <a href="https://app.srchamp.com" target="_blank" rel="noreferrer">
          Legacy Hub
        </a>
        <a href="https://api.srchamp.com" target="_blank" rel="noreferrer">
          API
        </a>
      </nav>
      <span className={styles.version} title={buildDetail()} data-bundle={BUILD.bundle}>
        {buildLabel()}
        {builtAtShort() && <span className={styles.built}> · built {builtAtShort()}</span>}
        <span className={styles.bundle}> · {BUILD.bundle}</span>
      </span>
    </footer>
  )
}
